import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
//import Gallery from '@/components/Gallery'
import { auth } from '../firebase'

import Login from '../views/Login.vue'
import Settings from '../views/Settings.vue'
import GalleryEdit from '../views/GalleryEdit.vue'
import Gallery from '../views/Gallery.vue'
import GalleryTest from '../views/GalleryTest.vue'
import GalleryUpload from '../views/GalleryUpload.vue'
import Participants from '../views/Participants.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    // component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
    component: Login,
  },
  {
    path: '/settings',
    name: 'settings',
    // component: () => import( /* webpackChunkName: "settings" */ '../views/Settings.vue'),
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gallery-edit/:id',
    name: 'galleryEdit',
    // component: () => import( /* webpackChunkName: "galleryEdit" */ '../views/GalleryEdit.vue'),
    component: GalleryEdit,
    meta: {
        requiresAuth: true
      }
  },
  {
    path: '/gallery-upload/:id',
    name: 'galleryUpload',
    // component: () => import( /* webpackChunkName: "galleryEdit" */ '../views/GalleryEdit.vue'),
    component: GalleryUpload,
    meta: {
        requiresAuth: true
      }
  },
  {
    path: '/gallery/:id',
    name: 'gallery',
    //component: () => import( /* webpackChunkName: "gallery" */ '../views/Gallery.vue'),
    component: Gallery,
    meta: {
        requiresAuth: true
      }
  },
  {
    path: '/gallery-test/:id',
    name: 'galleryTest',
    // component: () => import( /* webpackChunkName: "galleryTest" */ '../views/GalleryTest.vue'),
    component: GalleryTest,
    meta: {
        requiresAuth: true
      }
  },
  {
    path: '/participants/:id',
    name: 'Participants',
    // component: () => import( /* webpackChunkName: "galleryTest" */ '../views/GalleryTest.vue'),
    component: Participants,
    meta: {
        requiresAuth: true
      }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (requiresAuth && !auth.currentUser) {
    next('/login')
  } else {
    next()
  }
})

export default router
